<button 
    *ngIf="CanManageItem"
    [edlTooltip]="'View details for ' + userRequest.FirstName + ' ' + userRequest.LastName"
    [edlTooltipConfig]="{ 
        shouldTriggerOnKeydown: false
    }"
    class="btn btn-light border-0"
    (click)="openDetails()"
    [attr.aria-label]="'View details for ' + userRequest.FirstName + ' ' + userRequest.LastName">
    <i class="fas fa-info-circle" aria-hidden="true"></i>
</button>

